import { validationMessage } from 'shared/constants/message';
import * as yup from 'yup';

const numbersRegex: RegExp = /^[0-9,\s\n]*$/;

export const schema = yup.object({
  users: yup.string().matches(numbersRegex, validationMessage.user_ids),
});
